module.exports = __webpack_public_path__ + "img/location_a01.1579bbdc.svg";